module.exports = __webpack_public_path__ + "img/rootcube.2850bf52.webp";